import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

export default function Footer() {
  // Scroll to top instantly on navigation
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <footer className="footer">
      <div className="footer-overlay">
        <div className="container footer-content">
          {/* ==== Top Footer Columns ==== */}
          <div className="footer-grid">
            {/* Column 1 */}
            <div className="footer-col">
              <img alt="Logo" className="logo" src="/assets/img/ca-logo.jpg" />

              <h5 style={{ paddingTop: "10px" }}>SDPM & Co</h5>
              <h5>Chartered Accountants</h5>
              <p>
                Providing expert Chartered Accountancy, taxation, and business
                consulting services to help individuals and businesses achieve
                financial excellence.
              </p>
              <div className="footer-social">
                <a href="https://www.facebook.com/">
                  <FaFacebookF />
                </a>
                <a href="https://x.com/">
                  <FaTwitter />
                </a>
                <a href="https://in.linkedin.com/?mcid=6844056167778418689&src=go-pa&trk=sem-ga_campid.14650114788_asid.145595942605_crid.651893406697_kw.www%20linkedin%20com_d.c_tid.kwd-2246447642_n.g_mt.e_geo.9197679&cid=&gclsrc=aw.ds&gad_source=1&gad_campaignid=14650114788&gbraid=0AAAAABKX7wGLJy3lXA2ThnkEiAx5YY0qh&gclid=CjwKCAiA3rPKBhBZEiwAhPNFQL5LDCu4gn7Q1-WGQEA-Dha_yrUV3KT_CtQRLNTrL1OoevzYF-TaSBoCyr4QAvD_BwE">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.instagram.com/">
                  <FaInstagram />
                </a>
              </div>
            </div>

            {/* Column 2 */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <Link to="/" onClick={scrollToTop}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={scrollToTop}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/knowledgecenter"
                    onClick={() => {
                      scrollToTop();
                    }}
                  >
                    Knowledge Center
                  </Link>
                </li>
                <li>
                  <Link to="/career" onClick={scrollToTop}>
                    Career
                  </Link>
                </li>
                <li>
                  <Link to="/contactus" onClick={scrollToTop}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="footer-col">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <Link to="/audit-assurance" onClick={scrollToTop}>
                    Audit & Assurance
                  </Link>
                </li>
                <li>
                  <Link to="/taxation-compliance" onClick={scrollToTop}>
                    Taxation & Compliance
                  </Link>
                </li>
                <li>
                  <Link to="/corporate-compliance" onClick={scrollToTop}>
                    Corporate & ROC Compliances
                  </Link>
                </li>
                <li>
                  <Link to="/business-advisory" onClick={scrollToTop}>
                    Business Advisory
                  </Link>
                </li>
                <li>
                  <Link to="/banking-finance" onClick={scrollToTop}>
                    Banking & Project Finance
                  </Link>
                </li>
                <li>
                  <Link to="/capital-market-sebi" onClick={scrollToTop}>
                    Capital Market & SEBI
                  </Link>
                </li>
                <li>
                  <Link to="/international-nri" onClick={scrollToTop}>
                    International & NRI Services
                  </Link>
                </li>
                <li>
                  <Link to="/outsourcing-other" onClick={scrollToTop}>
                    Outsourcing & Other
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="footer-col">
              <h4>Contact Info</h4>

              <p className="footer-contact-item">
                <span className="footer-icon">📍</span>
                <Link
                  to="https://maps.app.goo.gl/A7ggRMu3m295Xa2dA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-link"
                >
                  H/O 1016, Anand Mangal – III, Opp Core House, Apollo City
                  Centre Lane, Ambawadi, Ahmedabad, Gujarat – 380015
                </Link>
              </p>

              <p className="footer-contact-item">
                <span className="footer-icon">📞</span>
                <a href="tel:+917948971100" className="footer-contact-link">
                  +91 79489 71100
                </a>
              </p>

              <p className="footer-contact-item">
                <span className="footer-icon">📧</span>
                <a
                  href="mailto:office@sdpmco.com"
                  className="footer-contact-link"
                >
                  office@sdpmco.com
                </a>
              </p>
            </div>
          </div>

          {/* ==== Bottom Footer ==== */}
          <div className="footer-bottom">
            <p>
              © {new Date().getFullYear()} <strong>S D P M & Co.</strong> All
              Rights Reserved. | Designed by{" "}
              <Link
                to="https://torbitmultisoft.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", textDecoration: "underline" }}
              >
                Torbit Multisoft
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
